var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { LangLoader } from "@irati/utils/lang";
import { SETUP_TENANT } from "@irati-web/app/src/routeConfig";
import Close from "@irati/ui/src/Close";
import { greys } from "@irati/ui/src/global/colors";
import { TooltipHeaderImage, TooltipWrapper, TooltipContent, CloseWrapper } from "./styled";
var PostSetupTooltip = /** @class */ (function (_super) {
    __extends(PostSetupTooltip, _super);
    function PostSetupTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PostSetupTooltip.prototype.render = function () {
        var _a = this.props, handleClose = _a.handleClose, children = _a.children;
        return (React.createElement(LangLoader, { bucket: SETUP_TENANT },
            React.createElement(TooltipWrapper, null,
                React.createElement(CloseWrapper, null,
                    React.createElement(Close, { top: "10px", right: "10px", onClick: handleClose, color: greys.mediumDark })),
                React.createElement(TooltipHeaderImage, null),
                React.createElement(TooltipContent, null, children))));
    };
    return PostSetupTooltip;
}(PureComponent));
export default PostSetupTooltip;
